import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";

export default function useClaims({
  db,
  userId,
  selectedPropertyId,
  canViewPropertyClaims = false,
}) {
  const [tenantResidencyClaims, setTenantResidencyClaims] = useState([]);
  const [propertyResidencyClaims, setPropertyResidencyClaims] = useState([]);

  useEffect(() => {
    if (!userId) {
      setTenantResidencyClaims([]);
      setPropertyResidencyClaims([]);
      return undefined;
    }

    const tenantClaimsQuery = query(
      collection(db, "propertyResidencyClaims"),
      where("tenantUserId", "==", userId)
    );

    return onSnapshot(
      tenantClaimsQuery,
      (snapshot) => {
        setTenantResidencyClaims(snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data(), scope: "tenant" })));
      },
      (error) => {
        console.error("Tenant residency claims listener error:", error);
        setTenantResidencyClaims([]);
      }
    );
  }, [db, userId]);

  useEffect(() => {
    if (!userId || !selectedPropertyId || !canViewPropertyClaims) {
      setPropertyResidencyClaims([]);
      return undefined;
    }

    const propertyClaimsQuery = query(
      collection(db, "propertyResidencyClaims"),
      where("propertyId", "==", selectedPropertyId)
    );

    return onSnapshot(
      propertyClaimsQuery,
      (snapshot) => {
        setPropertyResidencyClaims(snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data(), scope: "property" })));
      },
      (error) => {
        console.error("Property residency claims listener error:", error);
        setPropertyResidencyClaims([]);
      }
    );
  }, [db, userId, selectedPropertyId, canViewPropertyClaims]);

  return {
    tenantResidencyClaims,
    propertyResidencyClaims,
    residencyClaims: [...tenantResidencyClaims, ...propertyResidencyClaims],
  };
}
